/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { PortfolioTag } from './PortfolioTag'
import {
  PortfolioTagFromJSON,
  PortfolioTagFromJSONTyped,
  PortfolioTagToJSON,
} from './PortfolioTag'
import type { PortfolioWorkGallery } from './PortfolioWorkGallery'
import {
  PortfolioWorkGalleryFromJSON,
  PortfolioWorkGalleryFromJSONTyped,
  PortfolioWorkGalleryToJSON,
} from './PortfolioWorkGallery'

/**
 * Adds nested create feature
 * @export
 * @interface PortfolioWorkAdmin
 */
export interface PortfolioWorkAdmin {
  /**
   *
   * @type {number}
   * @memberof PortfolioWorkAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkAdmin
   */
  time?: string | null
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkAdmin
   */
  price?: string | null
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkAdmin
   */
  name?: string | null
  /**
   *
   * @type {Array<PortfolioWorkGallery>}
   * @memberof PortfolioWorkAdmin
   */
  gallery?: Array<PortfolioWorkGallery>
  /**
   *
   * @type {boolean}
   * @memberof PortfolioWorkAdmin
   */
  isPublished?: boolean
  /**
   *
   * @type {PortfolioTag}
   * @memberof PortfolioWorkAdmin
   */
  readonly tag: PortfolioTag | null
}

/**
 * Check if a given object implements the PortfolioWorkAdmin interface.
 */
export function instanceOfPortfolioWorkAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'tag' in value

  return isInstance
}

export function PortfolioWorkAdminFromJSON(json: any): PortfolioWorkAdmin {
  return PortfolioWorkAdminFromJSONTyped(json, false)
}

export function PortfolioWorkAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PortfolioWorkAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    time: !exists(json, 'time') ? undefined : json['time'],
    price: !exists(json, 'price') ? undefined : json['price'],
    name: !exists(json, 'name') ? undefined : json['name'],
    gallery: !exists(json, 'gallery')
      ? undefined
      : (json['gallery'] as Array<any>).map(PortfolioWorkGalleryFromJSON),
    isPublished: !exists(json, 'isPublished') ? undefined : json['isPublished'],
    tag: PortfolioTagFromJSON(json['tag']),
  }
}

export function PortfolioWorkAdminToJSON(value?: PortfolioWorkAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    time: value.time,
    price: value.price,
    name: value.name,
    gallery:
      value.gallery === undefined
        ? undefined
        : (value.gallery as Array<any>).map(PortfolioWorkGalleryToJSON),
    isPublished: value.isPublished,
  }
}
